<template>
  <div id="product">
    <breadcrumbs />

    <section class="product-start">
      <div class="container">
        <div class="product-start-name">
          <h1 class="product-name" data-testid="productName">
            {{ getCurrentProduct.name | htmlDecode }}
            <web-share
              :title="getCurrentProduct.name | htmlDecode"
              text="Check this product!"
              class="web-share"
            />
          </h1>
          <!--
          <div
              class="mb20 uppercase cl-secondary"
              :content="getCurrentProduct.sku"
            >
              {{ $t('SKU: {sku}', { sku: getCurrentProduct.sku }) }}
          </div>
          -->
        </div>

        <div class="product-data-shipping">
          <span class="badge badge-primary" v-if="getCurrentProduct.delivery_time"><router-link :to="localizedRoute('/lieferzeit')">{{ $t('Shipping Time') }} {{ getCurrentProduct.delivery_time }}</router-link></span>
          <span class="badge badge-primary">
            <matrixrates :product="getCurrentProduct" :hide-threshold="true" />
          </span>
          <span class="badge badge-primary" v-if="getCurrentProduct.min_order_quantity">
            {{ getCurrentProduct.min_order_quantity | htmlDecode }}
          </span>
        </div>
      </div>
    </section>

    <product-fence-height-selector
      :product="getCurrentProduct"
      :image="(getProductGallery[0]) ? getProductGallery[0]['src'] : ''"
      v-model="selectedHeight"
      v-if="isFence && showHeightSelector"
      ref="fenceHeightSelector"
    />

    <section class="product-main" id="product-main">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="product-main-image">
              <div class="product-gallery">
                <product-gallery
                  :offline="getOfflineImage"
                  :gallery="mediaGallery"
                  :configuration="getCurrentProductConfiguration"
                  :product="getCurrentProduct"
                />
              </div>
            </div>

            <zaun24-supplies-banner :product="getCurrentProduct" v-if="getCurrentProduct.is_supplies_active" />
          </div>

          <div class="col-md-6 col-lg-5">
            <div class="product-main-data">
              <div itemprop="offers" itemscope itemtype="http://schema.org/Offer">
                <meta itemprop="priceCurrency" :content="$store.state.storeView.i18n.currencyCode">
                <meta itemprop="price" :content="parseFloat(getCurrentProduct.price_incl_tax).toFixed(2)">
                <meta itemprop="url" :content="getCurrentProduct.url_path">

                <product-fence
                  ref="fence"
                  v-if="isFence"
                  :selected-height="selectedHeight"
                />

                <div class="product-configurator" v-if="!isFence">
                  <!-- div class="product-configurator-head">
                    Konfigurieren Sie ihr Produkt
                  </div -->

                  <div class="product-configurator-content">
                    <div class="variants">
                      <!--<div class="error" v-if="getCurrentProduct.errors && Object.keys(getCurrentProduct.errors).length > 0">
                      {{ getCurrentProduct.errors | formatProductMessages }}
                      </div>-->

                      <!--div class="product-configurator-option-wrapper" v-if="(!getCurrentProduct.errors || Object.keys(getCurrentProduct.errors).length === 0)">
                        <div class="product-configurator-option"
                          v-for="(option, index) in getCurrentProduct.configurable_options"
                          :key="index"
                        >
                          <div class="row">
                            <label :for="'select_' + option.attribute_code" class="configurator-option-head col-xs-4" data-testid="variantsLabel">
                              {{ option.label }}
                            </label>

                            <div class="configurator-option-content col-xs-8">
                              <select @change="changeFilter" :class="option.attribute_code" :id="'select_' + option.attribute_code" :aria-labelledby="'label_' + option.attribute_code">
                                  <option
                                    v-for="filter in getAvailableFilters[option.attribute_code]"
                                    :class="filter.id"
                                    :value="JSON.stringify(filter)"
                                    :key="filter.id"
                                  >
                                    {{ filter.label }}
                                  </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div -->

                      <configurable-options :product="getCurrentProduct" />

                      <product-links
                        v-if="getCurrentProduct.type_id =='grouped'"
                        :products="getCurrentProduct.product_links"
                      />
                      <product-bundle-options
                        v-if="getCurrentProduct.bundle_options && getCurrentProduct.bundle_options.length > 0"
                        :product="getCurrentProduct"
                      />
                      <product-custom-options
                        v-else-if="getCurrentProduct.custom_options && getCurrentProduct.custom_options.length > 0"
                        :product="getCurrentProduct"
                      />

                      <product-tier-prices
                        v-if="getCurrentProduct.tier_prices && getCurrentProduct.tier_prices.length > 0"
                        :product="getCurrentProduct"
                      />

                      <div class="product-configurator-summary">
                        <div class="configurator-summary-inner">
                          <div class="configurator-summary-price" v-if="getCurrentProduct.type_id !== 'grouped'">
                            <div v-if="getCurrentProduct.special_price && getCurrentProduct.price_incl_tax && getCurrentProduct.original_price_incl_tax">
                              <div class="price-old">
                                <span>{{ getCurrentProduct.original_price_incl_tax | price }}</span> *
                              </div>
                              <div class="price-offer discount">
                                {{ getCurrentProduct.price_incl_tax | price }} <span class="badge badge-sm badge-secondary">Sonderpreis</span>
                              </div>
                            </div>
                            <div class="price-offer" v-if="!getCurrentProduct.special_price && getCurrentProduct.price_incl_tax">
                              {{ getCurrentProduct.price_incl_tax | price }}
                            </div>

                            <product-base-price :product="getCurrentProduct" :price="getCurrentProduct.price_incl_tax" />

                            <div class="configurator-summary-tax">
                              <span v-if="storeView.storeCode === 'zaun24_de' && getCurrentProduct.tax_class_id === 1">inkl. 19% MwSt.,</span>
                              <span v-if="storeView.storeCode === 'zaun24_de' && getCurrentProduct.tax_class_id === 13">umsatzsteuerbefreit, gemäß §12 Abs. 3 UstG. *</span>
                              <span v-if="storeView.storeCode === 'zaun24_at' && getCurrentProduct.tax_class_id === 13">umsatzsteuerbefreit, gemäß § 28 Abs. 62 UstG. *</span>
                              <span v-else-if="storeView.storeCode === 'zaun24_at'">inkl. 20% MwSt.,</span>
                              <br>
                              <span class="product-delivery-time" v-if="getCurrentProduct.delivery_time"><router-link :to="localizedRoute('/lieferzeit')">{{ $t('Shipping Time') }} {{ getCurrentProduct.delivery_time }}</router-link>&nbsp;&nbsp;&middot;&nbsp;</span>
                              <matrixrates :product="getCurrentProduct" />
                              <strong v-if="getCurrentProduct.min_order_quantity">
                                <br>
                                {{ getCurrentProduct.min_order_quantity | htmlDecode }}
                              </strong>
                            </div>
                          </div>

                          <div
                            class="configurator-summary-quantity"
                            v-if="getCurrentProduct.type_id !== 'grouped' && getCurrentProduct.type_id !== 'bundle'"
                          >
                            <product-quantity
                              class="row m0 mb35"
                              v-if="getCurrentProduct.type_id !== 'grouped' && getCurrentProduct.type_id !== 'bundle'"
                              v-model="getCurrentProduct.qty"
                              :is-simple-or-configurable="isSimpleOrConfigurable"
                              show-quantity
                              @error="handleQuantityError"
                            />
                          </div>
                        </div>

                        <div class="configurator-summary-action">
                          <add-to-cart
                            :product="getCurrentProduct"
                            :disabled="isAddToCartDisabled"
                          />
                        </div>
                      </div>

                      <!--<div class="add-to-buttons">
                      <AddToWishlist :product="getCurrentProduct" />
                      <AddToCompare :product="getCurrentProduct" />
                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
              <!-- no-ssr v-if="!isFence">
                <zaun24-financing ref="financing" :price="getCurrentProduct.price_incl_tax" v-if="storeView.storeCode === 'zaun24_de'" />
              </no-ssr -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="product-description">
      <div class="container">
        <div class="row">
          <div
            :class="{
              'col-xs-12 product-description__left': true,
              'col-md-6': getCurrentProduct.short_description,
              'col-md-12': !getCurrentProduct.short_description
            }"
          >
            <div class="product-description__head">
              {{ $t('Product details') }}
            </div>

            <div
              class="product-description__content"
              itemprop="description"
              v-html="description"
            />
          </div>

          <div
            class="col-xs-12 col-md-6 product-description__right"
            v-if="getCurrentProduct.short_description || getCurrentProduct.downloads"
          >
            <LazyYoutubeVideo
              v-if="getYoutubeUrl"
              :src="getYoutubeUrl"
              :iframe-attributes="{width:560, height:315}"
            />

            <div
              v-if="getCurrentProduct.short_description"
              v-html="shortDescription"
              class="product-description-iframe"
            />

            <div
              v-if="getCurrentProduct.downloads"
              class="product-description-downloads"
            >
              <h3>{{ $t('Downloads') }}</h3>
              <div
                v-html="getCurrentProduct.downloads"
              />
            </div>

            <div
              class="product-description-gpsr"
            >
              <details>
                <summary>Angaben zur GPSR</summary>
                <span v-if="getCurrentProduct.gpsr" v-html="getCurrentProduct.gpsr" />
                <span v-else>
                  <p>Hersteller<br>decoga GmbH<br>Otto-Hahn-Straße 23<br>D-50997 Köln<br>gpsr@decoga.de</p>
                </span>
              </details>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="product-supplies-banner-mobile" v-if="getCurrentProduct.is_supplies_active">
      <div class="container">
        <zaun24-supplies-banner :product="getCurrentProduct" />
      </div>
    </section>

    <section class="product-more">
      <lazy-hydrate when-idle>
        <related-products-z24 type="catidzub" :heading="$t('Suitable Supplies')" />
      </lazy-hydrate>
      <lazy-hydrate when-idle>
        <related-products-z24 type="catidtor" :heading="$t('Suitable Gates')" />
      </lazy-hydrate>
      <!--
      <lazy-hydrate when-idle>
        <reviews
        :product-name="getCurrentProduct.name"
        :product-id="getCurrentProduct.id"
        v-show="isOnline"
        :product="getCurrentProduct"
        />
      </lazy-hydrate>
      <lazy-hydrate when-idle>
        <related-products type="upsell" :heading="$t('We found other products you might like')" />
      </lazy-hydrate>
      <lazy-hydrate when-idle>
        <promoted-offers single-banner />
      </lazy-hydrate>
      <lazy-hydrate when-idle>
        <related-products type="related" />
      </lazy-hydrate>
      -->
    </section>
    <script v-html="JSON.stringify(getJsonLd)" type="application/ld+json" />
  </div>
</template>

<script>
import i18n from '@vue-storefront/i18n'
import VueOfflineMixin from 'vue-offline/mixin'
import config from 'config'
// import RelatedProducts from 'theme/components/core/blocks/Product/Related.vue'
import Reviews from 'theme/components/core/blocks/Reviews/Reviews.vue'
import AddToCart from 'theme/components/core/AddToCart.vue'
import GenericSelector from 'theme/components/core/GenericSelector'
import ColorSelector from 'theme/components/core/ColorSelector.vue'
import SizeSelector from 'theme/components/core/SizeSelector.vue'
import Breadcrumbs from 'theme/components/core/Breadcrumbs.vue'
import ProductAttribute from 'theme/components/core/ProductAttribute.vue'
import ProductQuantity from 'theme/components/core/ProductQuantity.vue'
import ProductLinks from 'theme/components/core/ProductLinks.vue'
import ProductCustomOptions from 'theme/components/core/ProductCustomOptions.vue'
import ProductBundleOptions from 'theme/components/core/ProductBundleOptions.vue'
import ProductGallery from 'theme/components/core/ProductGallery'
import Spinner from 'theme/components/core/Spinner'
import PromotedOffers from 'theme/components/theme/blocks/PromotedOffers/PromotedOffers'
import focusClean from 'theme/components/theme/directives/focusClean'
import WebShare from 'theme/components/theme/WebShare'
// import BaseInputNumber from 'theme/components/core/blocks/Form/BaseInputNumber'
// import SizeGuide from 'theme/components/core/blocks/Product/SizeGuide'
// import AddToWishlist from 'theme/components/core/blocks/Wishlist/AddToWishlist'
// import AddToCompare from 'theme/components/core/blocks/Compare/AddToCompare'
import { mapGetters } from 'vuex'
import LazyHydrate from 'vue-lazy-hydration'
import { ProductOption } from '@vue-storefront/core/modules/catalog/components/ProductOption.ts'
import { getAvailableFiltersByProduct, getSelectedFiltersByProduct } from '@vue-storefront/core/modules/catalog/helpers/filters'
import { isOptionAvailableAsync } from '@vue-storefront/core/modules/catalog/helpers/index'
import { localizedRoute, currentStoreView } from '@vue-storefront/core/lib/multistore'
import { htmlDecode } from '@vue-storefront/core/filters'
import { ReviewModule } from '@vue-storefront/core/modules/review'
import { RecentlyViewedModule } from '@vue-storefront/core/modules/recently-viewed'
import { registerModule, isModuleRegistered } from '@vue-storefront/core/lib/modules'
import { onlineHelper, isServer, productJsonLd } from '@vue-storefront/core/helpers'
import { catalogHooksExecutors } from '@vue-storefront/core/modules/catalog-next/hooks'
// import ProductPrice from 'theme/components/core/ProductPrice.vue'
// import { doPlatformPricesSync } from '@vue-storefront/core/modules/catalog/helpers'
import { filterChangedProduct } from '@vue-storefront/core/modules/catalog/events'

/* Zaun24 */
import ProductBasePrice from 'theme/components/core/blocks/Product/BasePrice'
import ProductTierPrices from 'theme/components/core/blocks/Product/TierPrices'
import ProductFence from 'theme/components/core/blocks/Product/Fence'
import ProductFenceHeightSelector from 'theme/components/core/blocks/Product/Fence/HeightSelector'
import ConfigurableOptions from 'theme/components/core/blocks/Product/ConfigurableOptions'
import Matrixrates from 'src/modules/vsf-matrixrates/components/Matrixrates'
import RelatedProductsZ24 from 'theme/components/core/blocks/Product/Related.z24.vue'
import Zaun24SuppliesBanner from 'theme/components/core/blocks/Custom/Zaun24SuppliesBanner.vue'
import { getMediaGallery } from '@vue-storefront/core/modules/catalog/helpers'
import LazyYoutubeVideo from 'vue-lazy-youtube-video'

export default {

  components: {
    AddToCart,
    // AddToCompare,
    // AddToWishlist,
    Breadcrumbs,
    // ColorSelector,
    // GenericSelector,
    // ProductAttribute,
    ProductBundleOptions,
    ProductCustomOptions,
    ProductGallery,
    ProductLinks,
    // PromotedOffers,
    // RelatedProducts,
    // Reviews,
    // SizeSelector,
    WebShare,
    // SizeGuide,
    LazyHydrate,
    ProductQuantity,
    // ProductPrice,
    ProductFence,
    ProductFenceHeightSelector,
    ConfigurableOptions,
    Matrixrates,
    RelatedProductsZ24,
    Zaun24SuppliesBanner,
    // Zaun24Financing: () => import('theme/components/core/blocks/Custom/Zaun24Financing.vue'),
    ProductTierPrices,
    ProductBasePrice,
    LazyYoutubeVideo
  },
  mixins: [ProductOption],
  directives: { focusClean },
  beforeCreate () {
    registerModule(ReviewModule)
    registerModule(RecentlyViewedModule)
  },
  data () {
    return {
      detailsOpen: false,
      maxQuantity: 0,
      quantityError: false,
      isStockInfoLoading: false,
      hasAttributesLoaded: false,
      manageQuantity: false,
      selectedHeight: null,
      showHeightSelector: true
    }
  },
  computed: {
    ...mapGetters({
      getCurrentCategory: 'category-next/getCurrentCategory',
      getCurrentProduct: 'product/getCurrentProduct',
      getProductGallery: 'product/getProductGallery',
      getCurrentProductConfiguration: 'product/getCurrentProductConfiguration',
      attributesByCode: 'attribute/attributeListByCode',
      getCurrentCustomOptions: 'product/getCurrentCustomOptions'
    }),
    getOptionLabel () {
      return (option) => {
        const configName = option.attribute_code ? option.attribute_code : option.label.toLowerCase()
        return this.getCurrentProductConfiguration[configName] ? this.getCurrentProductConfiguration[configName].label : configName
      }
    },
    isOnline (value) {
      return onlineHelper.isOnline
    },
    getProductOptions () {
      if (
        this.getCurrentProduct.errors &&
        Object.keys(this.getCurrentProduct.errors).length &&
        Object.keys(this.getCurrentProductConfiguration).length
      ) {
        return []
      }
      return this.getCurrentProduct.configurable_options
    },
    getOfflineImage () {
      return {
        src: this.getThumbnail(this.getCurrentProduct.image, config.products.thumbnails.width, config.products.thumbnails.height),
        error: this.getThumbnail(this.getCurrentProduct.image, config.products.thumbnails.width, config.products.thumbnails.height),
        loading: this.getThumbnail(this.getCurrentProduct.image, config.products.thumbnails.width, config.products.thumbnails.height)
      }
    },
    getCustomAttributes () {
      return Object.values(this.attributesByCode || [])
        .filter(
          a => a.is_visible && a.is_user_defined && (parseInt(a.is_visible_on_front) || a.is_visible_on_front === true) && this.getCurrentProduct[a.attribute_code]
        )
        .sort((a, b) => { return a.attribute_id > b.attribute_id })
    },
    getAvailableFilters () {
      return getAvailableFiltersByProduct(this.getCurrentProduct)
    },
    getSelectedFilters () {
      return getSelectedFiltersByProduct(this.getCurrentProduct, this.getCurrentProductConfiguration)
    },
    isSimpleOrConfigurable () {
      return ['simple', 'configurable'].includes(this.getCurrentProduct.type_id)
    },
    isConfigurable () {
      return ['configurable'].includes(this.getCurrentProduct.type_id)
    },
    isAddToCartDisabled () {
      return false
    },
    storeView () {
      return currentStoreView()
    },
    getJsonLd () {
      return productJsonLd({
        ...this.getCurrentProduct,
        ...{
          category: null,
          stock: true,
          is_in_stock: true,
          price: this.getCurrentProduct.final_price
        }
      }, this.getCurrentProductConfiguration.color && this.getCurrentProductConfiguration.color.label, this.$store.state.storeView.i18n.currencyCode, this.getCustomAttributes)
    },
    mediaGallery () {
      return getMediaGallery(this.getCurrentProduct)
    },
    shortDescription () {
      return this.getCurrentProduct.short_description.replace(/<iframe.+?><\/iframe>/, '')
    },
    description () {
      if (this.isFence &&
        this.$refs &&
        this.$refs.fence
      ) {
        return this.$refs.fence.description
      }
      return this.getCurrentProduct.description
    },
    isFence () {
      return this.getCurrentProduct.attribute_set_id === 10
    },
    getYoutubeUrl () {
      if (this.getCurrentProduct.short_description) {
        const match = this.getCurrentProduct.short_description.match(/iframe src="(.+?)"/)
        return match ? match[1] : null
      }
      return null
    }
  },
  async mounted () {
    this.wrapElement('.product-description-iframe iframe', 'iframe-wrapper');
    await this.$store.dispatch('recently-viewed/addItem', this.getCurrentProduct)
  },
  async asyncData ({ store, route, context }) {
    if (context) context.output.cacheTags.add('product')
    const product = await store.dispatch('product/loadProduct', { parentSku: route.params.parentSku, childSku: route && route.params && route.params.childSku ? route.params.childSku : null })
    const loadBreadcrumbsPromise = store.dispatch('product/loadProductBreadcrumbs', { product })
    if (isServer) await loadBreadcrumbsPromise
    catalogHooksExecutors.productPageVisited(product)
  },
  beforeRouteEnter (to, from, next) {
    if (isServer) {
      next()
    } else {
      next((vm) => {
        vm.$store.dispatch('supplies/minify')
      })
    }
  },
  watch: {
    selectedHeight (option) {
      if (option) {
        this.changeFilter(option)
      }
    }
  },
  methods: {
    openHeightSelector () {
      this.$refs.fenceHeightSelector.openHeightSelector()
    },
    closeHeightSelector () {
      this.$refs.fenceHeightSelector.closeHeightSelector()
    },
    showDetails (event) {
      this.detailsOpen = true
      event.target.classList.add('hidden')
    },
    notifyOutStock () {
      this.$store.dispatch('notification/spawnNotification', {
        type: 'error',
        message: this.$t(
          'The product is out of stock and cannot be added to the cart!'
        ),
        action1: { label: this.$t('OK') }
      })
    },
    notifyWrongAttributes () {
      this.$store.dispatch('notification/spawnNotification', {
        type: 'warning',
        message: this.$t(
          'No such configuration for the product. Please do choose another combination of attributes.'
        ),
        action1: { label: this.$t('OK') }
      })
    },
    async changeFilter (variant) {
      const selectedConfiguration = Object.assign({ attribute_code: variant.type }, variant)
      await filterChangedProduct(selectedConfiguration, this.$store, this.$router)
    },
    isOptionAvailable (option) { // check if the option is available
      const currentConfig = Object.assign({}, this.getCurrentProductConfiguration)
      currentConfig[option.type] = option
      return isOptionAvailableAsync(this.$store, { product: this.getCurrentProduct, configuration: currentConfig })
    },
    handleQuantityError (error) {
      this.quantityError = error
    },
    wrapElement (toWrapSelector, wrapperClass) {
      const wrapper = document.createElement('div');
      wrapper.classList.add(wrapperClass);

      const toWrap = document.querySelector(toWrapSelector);
      if (toWrap) {
        toWrap.parentNode.appendChild(wrapper);
        wrapper.appendChild(toWrap);
      }
    }
  },
  metaInfo () {
    const storeView = currentStoreView()
    return {
      title: htmlDecode(this.getCurrentProduct.meta_title || this.getCurrentProduct.name),
      meta: this.getCurrentProduct.meta_description ? [{ vmid: 'description', name: 'description', content: htmlDecode(this.getCurrentProduct.meta_description) }] : [],
      link: [
        { rel: 'canonical', href: 'https://www.' + storeView.url + this.$route.path }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-primary: color(primary);
$color-tertiary: color(tertiary);
$color-secondary: color(secondary);
$color-white: color(white);
$bg-secondary: color(secondary, $colors-background);

.product {
  &__add-to-compare {
    display: none;
    @media (min-width: 767px) {
      display: block;
    }
  }
}

.breadcrumbs {
  @media (max-width: 767px) {
    margin: 15px 0;
    padding: 15px 0 0 15px;
  }
}
.data {
  @media (max-width: 767px) {
    border-bottom: 1px solid $bg-secondary;
  }
}

.image {
  @media (max-width: 1023px) {
    margin-bottom: 20px;
  }
}

.product-name {
  @media (max-width: 767px) {
    font-size: 36px;
  }
}

.price {
  @media (max-width: 767px) {
    color: $color-primary;
  }
}

.variants-label {
  @media (max-width: 767px) {
    font-size: 14px;
  }
}

.variants-wrapper {
  @media (max-width: 767px) {
    padding-bottom: 30px;
  }

 .sizes {
    @media (max-width: 767px) {
      width: 100%;
    }
  }

  .size-guide {
    height: 40px;
    @media (max-width: 767px) {
      width: 100%;
      margin-left: 0;
    }
  }
}

.product-top-section {
  @media (max-width: 767px) {
    padding: 0;
    background-color: $color-white;
  }
}

.add-to-buttons {
  @media (max-width: 767px) {
    padding-top: 30px;
    margin-bottom: 40px;
  }
}

.details {
  @media (max-width: 767px) {
    padding: 50px 15px 15px;
  }
}

.details-title {
  padding: 0 8px;

  @media (max-width: 767px) {
    font-size: 18px;
    margin: 0;
  }
}

.details-wrapper {
  @media (max-width: 767px) {
    position: relative;
    max-height: 140px;
    overflow: hidden;
    transition: all 0.3s ease;
    font-size: 14px;
  }

  &--open {
    max-height: none;
  }
}

.details-overlay {
  @media (max-width: 767px) {
    position: absolute;
    height: 75%;
    bottom: 0;
    left: 0;
    width: 100%;
    margin: 0;
    cursor: pointer;
    background: linear-gradient(rgba($color-white, 0), rgba($color-white, 1));
    &.hidden {
      display: none;
    }
  }
}

.price-original {
  text-decoration: line-through;
}

.action {
  &:hover {
    color: $color-tertiary;
  }
}

.attributes {
  list-style-type: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.product-image {
  mix-blend-mode: multiply;
  width: 460px;
}

.web-share {
  float: right;
}
</style>
